import { render } from "./Conduct.vue?vue&type=template&id=5b6f5252"
import script from "./Conduct.vue?vue&type=script&lang=js"
export * from "./Conduct.vue?vue&type=script&lang=js"

import "./Conduct.vue?vue&type=style&index=0&id=5b6f5252&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__